module.exports = __webpack_public_path__ + "img/stickers-taxe-fonciere.f6bee3b5.jpg";